import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPolicyPage } from "../privacy-policy";

export const Route = createFileRoute("/en/privacy-policy")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Privacy Policy | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Privacy Policy of Makedonijaturist AD. Information on how we collect, use, and protect your personal data.",
			},
			{
				name: "robots",
				content: "noindex, follow",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/privacy-policy",
			},
		],
	}),
	component: PrivacyPolicyPage,
});
